import OtpBox from './OtpBox';

export default OtpBox;
